import React, { useEffect, useState } from 'react';
import { projectsAPI } from '../../../services/api';
import api from '../../../services/api';
import './reports.css';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

/* ── Helpers ── */
function getInitials(name = '') {
  return name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2) || '?';
}
function parseDateParts(dateStr) {
  const d = new Date(dateStr);
  if (isNaN(d)) return { day: '--', mon: '---', full: dateStr };
  return {
    full: d.toLocaleDateString('default', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' }),
  };
}
function sumHours(tasks = []) {
  return tasks.reduce((s, t) => s + (parseFloat(t.actualHours) || 0), 0);
}

function formatHours(decimalHours) {
  const hours = Math.floor(decimalHours);
  const minutes = Math.round((decimalHours - hours) * 60);
  return `${hours}.${minutes.toString().padStart(2, '0')}`;
}

/* ── Log Card ── */
function LogCard({ plan, index }) {
  const [open, setOpen] = useState(index === 0);
  const { full } = parseDateParts(plan.date);
  const hrs = sumHours(plan.tasks);
  const taskCount = plan.tasks?.length || 0;
  const name = plan.user?.name || 'Unknown';

  return (
    <div className={`rp-log-card${open ? ' open' : ''}`} style={{ animationDelay: `${index * 45}ms` }}>
      <div className="rp-log-header" onClick={() => setOpen(o => !o)}>
        <div className="rp-log-header-left">
          <div className="rp-avatar">{getInitials(name)}</div>
          <div className="rp-log-meta">
            <span className="rp-log-user">{name}</span>
            <span className="rp-log-sub">
              📅 {full}
              <span className="rp-log-sub-dot" />
              {taskCount} task{taskCount !== 1 ? 's' : ''}
            </span>
          </div>
        </div>
        <div className="rp-log-header-right">
          <span className="rp-log-task-badge">{taskCount} tasks</span>
          {hrs > 0 && <span className="rp-log-hrs-badge">⏱ {formatHours(hrs)} hrs</span>}
          <svg className="rp-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </div>
      </div>

      <table className="rp-task-table">
        <thead>
          <tr>
            <th style={{ width: '35%' }}>Task</th>
            <th>Project</th>
            <th>Logs</th>
            <th>Hours</th>
          </tr>
        </thead>
        <tbody>
          {taskCount > 0 ? plan.tasks.map(task => {
            const hrs = parseFloat(task.actualHours) || 0;
            const project = task.backlogTask?.project?.name || task.project?.name || null;
            return (
              <tr className="rp-task-row" key={task.id}>
                <td>
                  <div className="rp-task-name">
                    <span className="rp-task-bullet" />
                    {task.title}
                  </div>
                </td>
                <td>
                  {project
                    ? <span className="rp-project-tag">📁 {project}</span>
                    : <span style={{ color: '#d1d5db', fontSize: 12 }}>—</span>
                  }
                </td>
                <td>
                  <span className="rp-notes-cell">{task.notes || '—'}</span>
                </td>
                <td>
                  <span className={`rp-hrs-cell ${hrs > 0 ? 'has' : 'none'}`}>
                    {hrs > 0 ? `${formatHours(hrs)} hrs` : '—'}
                  </span>
                </td>
              </tr>
            );
          }) : (
            <tr>
              <td colSpan={4} style={{ textAlign: 'center', color: '#9ca3af', padding: '16px', fontSize: 13 }}>
                No tasks recorded for this day.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

/* ── Main Component ── */
const Reports = () => {
  const [logs, setLogs] = useState([]);
  const [users, setUsers] = useState([]);
  const [projects, setProjects] = useState([]);
  const [userId, setUserId] = useState('');
  const [projectId, setProjectId] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    fetchUsers();
    fetchProjects();
    fetchLogs();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await api.get('/users');
      setUsers(res.data);
    } catch (err) { console.error(err); }
  };

  const fetchProjects = async () => {
    try {
      const res = await api.get('/projects');
      setProjects(res.data);
    } catch (err) { console.error(err); }
  };

  const fetchLogs = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await api.get('/daily-plans/admin/logs', {
        params: { userId, projectId, startDate, endDate }
      });
      setLogs(res.data);
      setHasLoaded(true);
    } catch (err) {
      console.error(err);
      setError('Failed to load logs. Please try again.');
    } finally {
      setLoading(false);
    }
  };


//   const handleExport = () => {
//   if (!logs || logs.length === 0) {
//     alert('No data to export');
//     return;
//   }

//   const data = [];

//   logs.forEach(plan => {
//     const userName = plan.user?.name || 'Unknown';
//     const date = new Date(plan.date).toLocaleDateString();

//     let filteredTasks = plan.tasks;

//     // ✅ APPLY SAME FILTER HERE
//     if (projectId) {
//       filteredTasks = plan.tasks.filter(task =>
//         task.project?.id == projectId ||
//         task.backlogTask?.project?.id == projectId
//       );
//     }

//     if (filteredTasks && filteredTasks.length > 0) {
//       filteredTasks.forEach(task => {
//         data.push({
//           Employee: userName,
//           Date: date,
//           Task: task.title,
//           Project: task.project?.name || task.backlogTask?.project?.name || '',
//           Logs: task.notes || '',
//           Hours: formatHours(parseFloat(task.actualHours) || 0)
//         });
//       });
//     }
//   });

//   if (data.length === 0) {
//     alert('No filtered data to export');
//     return;
//   }

//   const worksheet = XLSX.utils.json_to_sheet(data);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, 'Reports');

//   const excelBuffer = XLSX.write(workbook, {
//     bookType: 'xlsx',
//     type: 'array'
//   });

//   const blob = new Blob([excelBuffer], {
//     type: 'application/octet-stream'
//   });

//   saveAs(blob, 'filtered-reports.xlsx');
// };
  
const handleExport = () => {
  if (!logs || logs.length === 0) {
    alert('No data to export');
    return;
  }

  const data = [];
  let totalHours = 0;

  logs.forEach(plan => {
    const userName = plan.user?.name || 'Unknown';
    const date = new Date(plan.date).toLocaleDateString('en-GB'); 

    let filteredTasks = plan.tasks;

    if (projectId) {
      filteredTasks = plan.tasks.filter(task =>
        task.project?.id == projectId ||
        task.backlogTask?.project?.id == projectId
      );
    }

    if (filteredTasks && filteredTasks.length > 0) {
      filteredTasks.forEach(task => {
        const hrs = parseFloat(task.actualHours) || 0;
        totalHours += hrs;

        data.push([
          userName,
          date,
          task.title,
          task.project?.name || task.backlogTask?.project?.name || '',
          task.notes || '',
          formatHours(hrs)
        ]);
      });
    }
  });

  if (data.length === 0) {
    alert('No filtered data to export');
    return;
  }

  const header = ['Employee Name', 'Date', 'Task', 'Project', 'Logs', 'Hours'];

  const worksheet = XLSX.utils.aoa_to_sheet([header, ...data]);

  worksheet['!cols'] = [
    { wch: 15 },
    { wch: 12 },
    { wch: 25 },
    { wch: 18 },
    { wch: 30 },
    { wch: 10 }
  ];

  const totalRow = [
    '', '', '', '', 'Total Hours', formatHours(totalHours)
  ];

  XLSX.utils.sheet_add_aoa(worksheet, [totalRow], { origin: -1 });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Reports');

  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array'
  });

  const blob = new Blob([excelBuffer], {
    type: 'application/octet-stream'
  });

  const today = new Date().toISOString().slice(0, 10);
  saveAs(blob, `Reports-${today}.xlsx`);
}
  const handleReset = () => {
    setUserId('');
    setProjectId('');
    setStartDate('');
    setEndDate('');
  };

  return (
    <>
      <div className="rp-wrap">
        {/* ── Filter Card ── */}
        <div className="rp-filter-card">
          <div className="rp-filter-header">
            <span className="rp-filter-title">🔍 Filter Logs</span>
            <div className="rp-filter-divider" />
          </div>

          <div className="rp-filter-grid">
            <div className="rp-field">
              <label>Employee</label>
              <select value={userId} onChange={e => setUserId(e.target.value)}>
                <option value="">All Employees</option>
                {users
  .filter(u => u.role !== 'ADMIN')   
  .map(u => (
    <option key={u.id} value={u.id}>
      {u.name}
    </option>
  ))
}
              </select>
            </div>

            <div className="rp-field">
              <label>Project</label>
              <select value={projectId} onChange={e => setProjectId(e.target.value)}>
                <option value="">All Projects</option>
                {projects.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
              </select>
            </div>

            <div className="rp-field">
              <label>From Date</label>
              <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} />
            </div>

            <div className="rp-field">
              <label>To Date</label>
              <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} />
            </div>
          </div>

          <div className="rp-filter-actions">
            <button className="rp-btn-reset" onClick={handleReset}>↺ Reset</button>
            <button className="rp-btn-apply" onClick={fetchLogs} disabled={loading}>
              {loading ? '⏳ Loading…' : '🔍 Apply Filters'}
            </button>
            <button
              style={{
                background: '#16a34a',
                color: 'white',
                border: 'none',
                padding: '9px 18px',
                borderRadius: '9px',
                cursor: 'pointer'
              }}
              onClick={handleExport}
            >
              📥 Export
            </button>
          </div>
        </div>

        {/* ── Error ── */}
        {error && (
          <div className="rp-error-box">
            <span className="rp-error-msg">⚠️ {error}</span>
            <button className="rp-retry-btn" onClick={fetchLogs}>Retry</button>
          </div>
        )}

        {/* ── Skeletons ── */}
        {loading && [1, 2, 3, 4].map(i => <div key={i} className="rp-skeleton" />)}

        {/* ── Results header ── */}
        {!loading && !error && hasLoaded && logs.length > 0 && (
          <div className="rp-results-header">
            <span className="rp-results-label">Showing results</span>
            <span className="rp-results-count">{logs.length} entr{logs.length === 1 ? 'y' : 'ies'}</span>
          </div>
        )}

        {/* ── Empty ── */}
        {!loading && !error && hasLoaded && logs.length === 0 && (
          <div className="rp-empty-box">
            <div className="rp-empty-icon">📭</div>
            <div className="rp-empty-title">No logs found</div>
            <div className="rp-empty-sub">Try adjusting your filters or selecting a different date range.</div>
          </div>
        )}

        {/* ── Log Cards ── */}
        {!loading && !error && logs.map((plan, i) => {
          let filteredTasks = plan.tasks;

          // ✅ Apply project filter
          if (projectId) {
            filteredTasks = plan.tasks.filter(task =>
              task.project?.id == projectId ||
              task.backlogTask?.project?.id == projectId
            );
          }

          return (
            <LogCard
              key={plan.id}
              plan={{ ...plan, tasks: filteredTasks }}
              index={i}
            />
          );
        })}

      </div>
    </>
  );
};

export default Reports;